import React from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import stylesPc from "./PresenterSlideGroup.module.css";
import stylesSp from "./PresenterSlideGroup_SP.module.css";
import "./navigationButton.css";
import { useHistory } from "react-router-dom";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import SlideNextIcon from "../images/SlideNextIcon";
import SlidePrevIcon from "../images/SlidePrevIcon";
import { VerticalList } from "../../homePage/model/HomePage";
import { resetfilter } from "../../video/VideoFilterActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import { useDispatch } from "react-redux";
import { IsDevice } from "../../../components/function/useDeviceFlag";

SwiperCore.use([Navigation]);

// スライドの型定義
export interface PresenterSlideGroupProps {
    // id
    id: string;
    // 一列に表示させる画像数
    displayNum: number;
    // 画像のループ切り替え
    needLoop: boolean;
    // プレゼンターリスト
    presenterList: VerticalList[];
}

export default function PresenterSlideGroup({
    id,
    displayNum,
    presenterList,
    needLoop,
}: PresenterSlideGroupProps) {
    const dispatch = useDispatch();
    const history = useHistory();
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    // プレゼンタークリックイベント
    const HandleClick = (id: string, name: string) => {
        const presenterFilter = {
            id: id === "" ? [] : [id],
            professional: name === "" ? [] : [name],
            program: [],
            project: [],
            tag: [],
        };
        dispatch(resetfilter(presenterFilter));
        history.push("videos");
    };

    return (
        <div style={{ position: "relative" }}>
            {((IsDevice("desktop") && presenterList.length > 5) ||
                (IsDevice("ipad") && presenterList.length > 3) ||
                (IsDevice("iphone") && presenterList.length > 2)) && (
                <>
                    <div
                        className={`${styles.swiperButtonDiv} swiper-presenter-next-${id} swiper-presenter-next swiper-button-disabled`}
                        style={{
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "10px",
                            height: "100%",
                            right: IsDevice("desktop")
                                ? "-30px"
                                : IsDevice("ipad")
                                ? "-19px"
                                : "-11px",
                            top: IsDevice("desktop") ? "0px" : "-9px",
                            zIndex: 10,
                            cursor: "pointer",
                        }}
                    >
                        <div className={styles.swiperButton}>
                            <SlideNextIcon />
                        </div>
                    </div>
                    <div
                        className={`${styles.swiperButtonDiv} swiper-presenter-prev-${id} swiper-presenter-prev swiper-button-disabled`}
                        style={{
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "10px",
                            height: "100%",
                            left: IsDevice("desktop")
                                ? "-30px"
                                : IsDevice("ipad")
                                ? "-19px"
                                : "-12px",
                            top: IsDevice("desktop") ? "0px" : "-9px",
                            zIndex: 10,
                            cursor: "pointer",
                        }}
                    >
                        <div className={styles.swiperButton}>
                            <SlidePrevIcon />
                        </div>
                    </div>
                </>
            )}
            <Swiper
                className={styles.swiperContainer}
                spaceBetween={15}
                slidesPerView={displayNum}
                loop={needLoop ? (presenterList.length >= displayNum ? true : false) : false}
                loopFillGroupWithBlank={
                    needLoop ? (presenterList.length >= displayNum ? false : true) : true
                }
                navigation={{
                    nextEl: `.swiper-presenter-next-${id}`,
                    prevEl: `.swiper-presenter-prev-${id}`,
                }}
                style={{ height: "100px" }}
            >
                {presenterList.map((row, index) => (
                    <SwiperSlide key={`${id}-${index}`}>
                        <div
                            key={row.title}
                            className={styles.cardActionArea}
                            onClick={() => HandleClick(row.id, row.title)}
                        >
                            <div key={row.title} className={styles.cardContent}>
                                <img
                                    src={row.imageUrl}
                                    className={styles.avatar}
                                    alt={row.title}
                                    onError={(e) =>
                                        (e.currentTarget.src =
                                            require("../../../assets/image/noPresenterImage.svg").default)
                                    }
                                />
                                <div className={styles.content}>
                                    <div
                                        className={styles.name}
                                        data-tip={row.title}
                                        data-for="name"
                                    >
                                        <PuiTypography
                                            bold={true}
                                            rows={2}
                                            size={IsDevice("desktop") ? 16 : 14}
                                        >
                                            <span className={styles.title}>{row.title}</span>
                                        </PuiTypography>
                                        <PuiTooltip id={"name"} />
                                    </div>
                                    {row.sub !== undefined && (
                                        <div className={styles.remark}>
                                            <PuiTypography
                                                color="secondary-font"
                                                size={IsDevice("desktop") ? 14 : 10}
                                            >
                                                {row.sub}
                                            </PuiTypography>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
